import { render, staticRenderFns } from "./LeadSourceForm.vue?vue&type=template&id=5b47fc4f&scoped=true&"
import script from "./LeadSourceForm.vue?vue&type=script&lang=js&"
export * from "./LeadSourceForm.vue?vue&type=script&lang=js&"
import style0 from "./LeadSourceForm.vue?vue&type=style&index=0&id=5b47fc4f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b47fc4f",
  null
  
)

export default component.exports